import { render, staticRenderFns } from "./bShengXue.vue?vue&type=template&id=193d60d1&scoped=true&"
import script from "./bShengXue.vue?vue&type=script&lang=js&"
export * from "./bShengXue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d60d1",
  null
  
)

export default component.exports